/* PostureCozy theme JS — cart drawer (AJAX), variant picker, UI behaviours */
(function(){
  const money = function(cents){
    var f = (window.PC && window.PC.moneyFormat) || '€{{amount}}';
    var n = (cents || 0) / 100;
    var grp = function(dec, th, dp){
      var s = Math.abs(n).toFixed(dec), parts = s.split('.');
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return (n < 0 ? '-' : '') + (parts[1] ? i + dp + parts[1] : i);
    };
    return f
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, grp(0,'.',''))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, grp(0,' ',''))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, grp(2,'.',','))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, grp(2,' ',','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, grp(2,"'",'.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, grp(0,',',''))
      .replace(/\{\{\s*amount\s*\}\}/g, grp(2,',','.'));
  };
  const $ = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));
  const threshold = (window.PC && window.PC.freeShipThreshold) || 6000;

  /* ---------- cart drawer ---------- */
  const drawer = $('#pc-drawer'), scrim = $('#pc-scrim');
  function openCart(){ if(drawer){drawer.classList.add('show');scrim.classList.add('show');document.body.style.overflow='hidden';} }
  function closeCart(){ if(drawer){drawer.classList.remove('show');scrim.classList.remove('show');document.body.style.overflow='';} }
  window.PCopenCart = openCart; window.PCcloseCart = closeCart;
  window.PCrefresh = function(){ return refresh(); };

  async function getCart(){ const r = await fetch('/cart.js'); return r.json(); }
  function renderDrawer(cart){
    const body = $('#pc-drawer-body'); if(!body) return;
    $$('.cartcount').forEach(e=>e.textContent = cart.item_count);
    if(!cart.items.length){
      body.innerHTML = '<p class="dempty">Your cart is empty.</p>';
    } else {
      body.innerHTML = cart.items.map(it=>`
        <div class="ditem" data-key="${it.key}">
          <div class="dimg">${it.image?`<img src="${it.image.replace(/(\.[^.]+)$/,'_120x120$1')}" alt="${it.product_title}">`:''}</div>
          <div class="dinfo">
            <div class="dn">${it.product_title}</div>
            <div class="dv">${it.variant_title && it.variant_title!=='Default Title'?it.variant_title:''}</div>
            <div class="qctrl">
              <button data-act="dec" aria-label="Decrease">−</button>
              <span>${it.quantity}</span>
              <button data-act="inc" aria-label="Increase">+</button>
            </div>
            <a class="dremove" data-act="rm">Remove</a>
          </div>
          <div class="dpr">${money(it.final_line_price)}</div>
        </div>`).join('');
    }
    $('#pc-subtotal') && ($('#pc-subtotal').textContent = money(cart.total_price));
    $('#pc-cosub') && ($('#pc-cosub').textContent = money(cart.total_price));
    const bar = $('#pc-shipbar'), txt = $('#pc-shiptxt');
    if(bar){
      // Shipping is free on every order with no minimum, so there is no
      // threshold to make progress toward - state it plainly instead.
      bar.style.width = '100%';
      txt.innerHTML = "\u{1F389} Free worldwide shipping included";
    }
  }
  async function refresh(){ renderDrawer(await getCart()); }

  async function addItem(id, qty){
    const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})});
    if(!r.ok){ const e=await r.json(); alert(e.description||'Could not add to cart'); return; }
    await refresh(); openCart();
  }
  async function changeItem(key, qty){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    await refresh();
  }

  document.addEventListener('click', (e)=>{
    const open = e.target.closest('[data-pc="open-cart"]'); if(open){e.preventDefault();openCart();}
    const close = e.target.closest('[data-pc="close-cart"]'); if(close){e.preventDefault();closeCart();}
    const item = e.target.closest('.ditem'); if(item){
      const key = item.dataset.key, qSpan = item.querySelector('.qctrl span'), q = parseInt(qSpan.textContent,10);
      if(e.target.dataset.act==='inc') changeItem(key, q+1);
      if(e.target.dataset.act==='dec') changeItem(key, q-1);
      if(e.target.dataset.act==='rm') changeItem(key, 0);
    }
    const adder = e.target.closest('[data-pc-add]'); if(adder){ e.preventDefault(); addItem(parseInt(adder.dataset.pcAdd,10), 1); }
  });

  /* ---------- accordion ---------- */
  window.PCtoggle = function(btn){
    const ai = btn.parentElement, ab = btn.nextElementSibling, open = ai.classList.contains('open');
    ai.closest('.acc').querySelectorAll('.ai').forEach(x=>{x.classList.remove('open');x.querySelector('.ab').style.maxHeight=null;});
    if(!open){ ai.classList.add('open'); ab.style.maxHeight = ab.scrollHeight+'px'; }
  };

  /* ---------- gallery ---------- */
  window.PCslide = function(i, root){
    root = root || document;
    const wrap = $('#pc-slidewrap', root); if(!wrap) return;
    wrap.style.transform = `translateX(-${i*100}%)`;
    $$('#pc-gnav i', root).forEach((d,x)=>d.classList.toggle('on',x===i));
    $$('#pc-thumbs button', root).forEach((b,x)=>b.classList.toggle('on',x===i));
  };

  /* ---------- announcement rotator (fade, auto-height) ---------- */
  $$('.announce__track').forEach(function(track){
    var msgs = $$('.announce__msg', track);
    if(msgs.length < 2) return;
    var secs = parseInt(track.dataset.rotate,10) || 4;
    var a = 0;
    setInterval(function(){
      msgs[a].classList.remove('is-active');
      a = (a+1) % msgs.length;
      msgs[a].classList.add('is-active');
    }, secs*1000);
  });

  /* ---------- sticky atc ---------- */
  const sticky = $('#pc-sticky');
  if(sticky){ window.addEventListener('scroll', ()=>{ sticky.classList.toggle('show', window.scrollY>620 && window.scrollY < document.body.scrollHeight-1100); }); }

  /* ---------- countdown ---------- */
  const ctd = $('#pc-ctd');
  if(ctd){ let t = 11*60+42; setInterval(()=>{ if(t>0)t--; const m=String(Math.floor(t/60)).padStart(2,'0'),s=String(t%60).padStart(2,'0'); ctd.textContent='offer ends in '+m+':'+s; },1000); }

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);} }),{threshold:.12});
  $$('.reveal').forEach(el=>io.observe(el));

  /* ---------- mobile menu ---------- */
  window.PCmenu = function(){ const m=$('#pc-mobilemenu'); if(m) m.classList.toggle('open'); };

  /* ---------- quantity stepper (product) ---------- */
  document.addEventListener('click',(e)=>{
    const s = e.target.closest('[data-qstep]'); if(!s) return;
    const input = s.parentElement.querySelector('input'); if(!input) return;
    let v = parseInt(input.value,10)||1; v += parseInt(s.dataset.qstep,10); if(v<1)v=1; input.value=v;
  });

  /* init drawer state on load */
  document.addEventListener('DOMContentLoaded', refresh);
})();

/* ---------- product form AJAX (added) ---------- */
(function(){
  document.addEventListener('submit', async (e)=>{
    const form = e.target.closest('form.pc-product-form');
    if(!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    if(btn){ btn.dataset.label = btn.innerHTML; btn.innerHTML = 'Adding…'; btn.disabled = true; }
    try{
      const r = await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
      if(!r.ok){ const er = await r.json(); throw new Error(er.description||'Could not add to cart'); }
      // Open the cart drawer rather than teleporting to checkout. Shoppers who
      // tapped "add to cart" to look at the cart were landing on a full address
      // form they never asked for, and 9 in 10 left before typing anything.
      if(btn){ btn.innerHTML = btn.dataset.label; btn.disabled = false; }
      if(window.PCrefresh){ await window.PCrefresh(); }
      if(window.PCopenCart){ window.PCopenCart(); } else { window.location.href = '/cart'; }
    }catch(err){ alert(err.message); if(btn){ btn.innerHTML = btn.dataset.label; btn.disabled=false; } }
  });
})();

/* ---------- product gallery: swipe by touch / mouse drag ---------- */
(function(){
  var wrap = document.getElementById('pc-slidewrap');
  if(!wrap) return;
  var count = wrap.querySelectorAll('.gslide').length;
  if(count < 2) return;
  var idx = 0, startX = 0, startY = 0, dx = 0, axis = null, dragging = false;

  // keep idx in sync with dot/thumb clicks (they call window.PCslide)
  var orig = window.PCslide;
  window.PCslide = function(i){ if(typeof i === 'number') idx = i; return orig.apply(this, arguments); };

  function translate(px){ wrap.style.transform = 'translateX(calc(' + (-idx*100) + '% + ' + px + 'px))'; }
  function snap(n){ idx = Math.max(0, Math.min(count-1, n)); wrap.style.transition = ''; orig(idx); }
  function start(x,y){ dragging = true; startX = x; startY = y; dx = 0; axis = null; wrap.style.transition = 'none'; }
  function move(x,y,e){
    if(!dragging) return;
    var mx = x - startX, my = y - startY;
    if(axis === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
    if(axis !== 'x') return;                 // vertical: let the page scroll
    if(e && e.cancelable) e.preventDefault();
    dx = mx;
    if((idx === 0 && dx > 0) || (idx === count-1 && dx < 0)) dx *= 0.35; // edge resistance
    translate(dx);
  }
  function end(){
    if(!dragging) return;
    dragging = false;
    wrap.style.transition = '';
    var threshold = Math.min(70, wrap.offsetWidth * 0.18);
    if(dx <= -threshold) snap(idx + 1);
    else if(dx >= threshold) snap(idx - 1);
    else orig(idx);
  }
  wrap.addEventListener('touchstart', function(e){ start(e.touches[0].clientX, e.touches[0].clientY); }, {passive:true});
  wrap.addEventListener('touchmove', function(e){ move(e.touches[0].clientX, e.touches[0].clientY, e); }, {passive:false});
  wrap.addEventListener('touchend', end);
  wrap.addEventListener('touchcancel', end);
  wrap.addEventListener('mousedown', function(e){ e.preventDefault(); start(e.clientX, e.clientY); });
  window.addEventListener('mousemove', function(e){ if(dragging){ if(axis === null) axis = 'x'; move(e.clientX, e.clientY, e); } });
  window.addEventListener('mouseup', end);
})();

/* ---------- product gallery: load only the first image up front, hydrate the rest after it ---------- */
(function(){
  var wrap = document.getElementById('pc-slidewrap');
  if(!wrap) return;
  var imgs = Array.prototype.slice.call(wrap.querySelectorAll('.gslide img'));
  if(imgs.length < 2) return;
  function hydrate(img){
    if(!img || !img.dataset.src) return;
    if(img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
  }
  function hydrateAll(){ imgs.forEach(hydrate); }
  // hydrate a slide (and neighbours) the moment it's navigated to — keeps the LCP image alone on the wire at first
  var prev = window.PCslide;
  window.PCslide = function(i){ if(typeof i === 'number'){ hydrate(imgs[i]); hydrate(imgs[i+1]); hydrate(imgs[i-1]); } return prev ? prev.apply(this, arguments) : undefined; };
  // load the rest only once the first (LCP) image is done
  var first = imgs[0];
  if(first.complete) hydrateAll();
  else { first.addEventListener('load', hydrateAll, { once:true }); first.addEventListener('error', hydrateAll, { once:true }); }
  window.addEventListener('load', hydrateAll);
  wrap.addEventListener('touchstart', function(){ hydrate(imgs[1]); }, { once:true, passive:true });
})();

/* ---------- variant feedback when the gallery is off-screen ---------- */
// On phones the pickers sit far below the gallery, so a variant change moved the
// carousel where nobody could see it. Every picker ends in PCslide, so hook there:
// keep the active thumbnail scrolled into its strip, and if the shopper is down at
// the picker, float a small preview of the new image they can tap to jump up to.
(function(){
  var orig = window.PCslide;
  if(typeof orig !== 'function') return;
  var cfg = (window.PC && window.PC.vpreview) || {};
  var LABEL = cfg.label || 'You selected', BTN = cfg.btn || 'See it', MS = (+cfg.seconds || 3.6) * 1000;
  var lastPick = 0;
  ['pointerdown','click','change'].forEach(function(t){
    document.addEventListener(t, function(e){
      if(e.target && e.target.closest && !e.target.closest('.gallery')) lastPick = Date.now();
    }, true);
  });

  function centerThumb(){
    var strip = document.getElementById('pc-thumbs');
    var btn = strip && strip.querySelector('button.on');
    if(!btn) return;
    var s = strip.getBoundingClientRect(), b = btn.getBoundingClientRect();
    var left = strip.scrollLeft + (b.left - s.left) - (s.width - b.width) / 2;
    try{ strip.scrollTo({ left: left, behavior: 'smooth' }); }catch(e){ strip.scrollLeft = left; }
  }

  // Shopify publishes variant names on every product page; name the choice, not the photo
  function variantName(){
    var id = String((document.getElementById('pc-variant-id')||{}).value||'');
    var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var v = m && (m.variants||[]).find(function(x){ return String(x.id) === id; });
    return v ? (v.public_title || v.name || '') : '';
  }

  var card, hideTimer;
  function ensureCard(){
    if(card) return card;
    card = document.createElement('button');
    card.type = 'button';
    card.className = 'vpreview';
    card.setAttribute('aria-live', 'polite');
    card.innerHTML = '<img alt=""><span class="vpreview__body"><span class="vpreview__k"></span><span class="vpreview__t"></span></span><span class="vpreview__go"></span>';
    card.querySelector('.vpreview__k').textContent = '✓ ' + LABEL;
    card.querySelector('.vpreview__go').textContent = BTN;
    card.addEventListener('click', function(){
      var g = document.querySelector('.gallery');
      if(g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
      card.classList.remove('show');
    });
    document.body.appendChild(card);
    return card;
  }
  function showPreview(i){
    if(cfg.on === false) return;
    if(window.innerWidth > 900) return;               // desktop: gallery is beside the picker
    if(Date.now() - lastPick > 1500) return;          // only for the shopper's own choice
    var g = document.querySelector('.gmain');
    if(!g) return;
    var r = g.getBoundingClientRect();
    var visible = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0)) / Math.max(1, r.height);
    if(visible > 0.35) return;                         // they can already see it change
    var slide = document.querySelectorAll('#pc-slidewrap .gslide')[i];
    var img = slide && slide.querySelector('img');
    if(!img) return;
    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    if(!src) return;
    var c = ensureCard();
    c.querySelector('img').src = src.replace(/([?&]width=)\d+/, '$1240');
    c.querySelector('.vpreview__t').textContent = variantName() || img.getAttribute('alt') || 'Your selection';
    c.classList.remove('pop'); void c.offsetWidth; c.classList.add('show','pop');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function(){ c.classList.remove('show'); }, MS);
  }

  window.PCslide = function(i){
    var out = orig.apply(this, arguments);
    if(typeof i === 'number'){
      centerThumb();
      // run after the current event finishes dispatching: bundle apps move the gallery from
      // a capture listener that fires before ours has recorded the shopper's pick
      setTimeout(function(){ showPreview(i); }, 0);
    }
    return out;
  };
})();
